import api from "../api/CustomerApi";

export const OrderServices = {
  placeOrder: async (payload) => {
    const res = await api.post("/orders", payload);
    return res.data;
  },

  createPaymentIntent: async ({ amount, currency = "usd" }) => {
    const res = await api.post("/stripe/create-payment-intent", {
      amount,
      currency,
    });
    return res.data;
  },

  createPayPalPayment: async (orderId) => {
    const res = await api.post("/paypal/create-payment", {
      order_id: orderId,
    });
    return res.data;
  },

  executePayPalPayment: async (paymentId, orderId) => {
    const res = await api.post("/paypal/execute-payment", {
      payment_id: paymentId,
      order_id: orderId,
    });
    return res.data;
  },

  cancelPayPalPayment: async (orderId) => {
    const res = await api.post("/paypal/cancel-payment", {
      order_id: orderId,
    });
    return res.data;
  },

  getMyOrders: async () => {
    const res = await api.get("/orders");
    return res.data;
  },

  getOrderById: async (id) => {
    const res = await api.get(`/orders/${id}`);
    return res.data;
  },

  validateCoupon: async (code, subtotal) => {
    const res = await api.post("/coupons/validate", { code, subtotal });
    return res.data;
  },

  getShipmentUrl: async (orderId) => {
    const res = await api.get(`/my-orders/${orderId}/shipment-url`);
    return res.data;
  },

  cancelOrder: async (orderId) => {
    const res = await api.patch(`/orders/${orderId}/cancel`);
    return res.data;
  },

  getLocations: async () => {
    const res = await api.get("/locations");
    return res.data?.data || [];
  },

  getStates: async () => {
    const res = await api.get("/states");
    return res.data?.data || [];
  },
};